import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';
import ProductControl from '@/blocks.04-project/product-control/product-control';

/***
 * Класс карточек товара
 * @example
 *
 * Классы:
 * .product-card_slider-inited - слайдер проинициализирован после взаимодействия
 */
class ProductCard extends ProductControl {
  /***
   * Конструктор класса
	 * @param selector {String} селектор для поиска блока
	 * @param options {Object} данные карточки
	 * @param elem {HTMLElement|undefined} элемент для инициализации
   */
  constructor({ selector, options, elem }) {
		super({ blockClass: 'product-card', selector, options, elem });
		this.BlockError = new BlockError({ blockName: 'ProductCard', destroy: this.destroy });
		this.block.ProductCard = this;
		this.block.AsyncProductCard = new Promise((resolve) => {
			this.promiseResolve = resolve;
		}).then((ins) => ins);

		this.LazyInit = new LazyInit({ ins: this, callback: this.init.bind(this), addClass: 'product-card_inited' });
		if (!this.bh) {
			window.getBH((bh) => {
				this.bh = bh;
				this.LazyInit.init();
			});
		} else {
			this.LazyInit.init();
		}
  }

	async init() {
		await super.init();
		this.initSlider();
		this.promiseResolve(this);
		this.block.AsyncProductCard = this;
	}

	initSlider() {
		this.productCardSliderContainer = this.block.querySelector('.product-card-slider');
		if (!this.productCardSliderContainer) return;

		this.ProductCardSlider = new window.Block.ProductCardSlider(this.productCardSliderContainer);
		if (!this.ProductCardSlider) return this.BlockError.error('Отсутствует инстанс ProductCardSlider');
	}

	render() {
		super.render();
		this.ProductCardSlider?.update();
	}

  destroy() {
		super.destroy();
		if (this.LazyInit) this.LazyInit.destroy();
		if (this.ProductCardSlider) this.ProductCardSlider.destroy();
    if (this.block) {
      this.block.classList.remove('product-card_inited');
      delete this.block.ProductCard;
      delete this.block.AsyncProductCard;
    }
  }
}

if (NOT_PROD) {
	const options = {
			data: {
				'id': 25625,
				'currentOfferId': 24610,
				'title': 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
				'description': '',
				'vat': 'с НДС',
				'colors': [],
				'languages': [],
				'rating': 4.222222222,
				'reviews': 5,
				'offers': [
					{
						'specsPreview': [
							{
								'title': 'Короткое описание',
								'description': 'Короткое описание'
							},
							{
								'title': 'Длинное описание',
								'description': 'Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание'
							},
							{
								'title': 'Очень длинное описание',
								'description': 'Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание Длинное описание'
							}
						],
						'id': 24610,
						'substitutesUrl': '#',
						'name': 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
						'article': '69698',
						'photos': [
							{
								src: '/upload/iv_resize_cache/iblock/525/x8z4jbhowhq65dvlh42rrnl630lx87j1/microscope-telescope-binocular-levenhuk-labzz-mtb3_R90i5ho_190_190c90d8ac7541f58f7b6ddfe6e7f522a2f.webp',
								alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
							},
						],
						'margin': null,
						'price': '6&nbsp;690 &#8381;',
						'priceValue': 6690,
						'oldPrice': '',
						'quantity': 898,
						'color': null,
						'lang': null,
						'status': {
							'code': 'IN_STOCK',
							'text': 'В наличии'
						},
						'badges': [
							{
								'icon': 'polygon',
								'code': 'hot',
								'text': 'БЕСТСЕЛЛЕР'
							},
							{
								'icon': 'infinity',
								'code': 'lifetime',
								'text': 'БЕССРОЧНАЯ ГАРАНТИЯ'
							},
							{
								'icon': 'fire',
								'code': 'new',
								'text': 'Новинка'
							},
							//Right badges
							{
								'src': './images/badges/free-delivery.svg',
								'code': 'free_shipping',
								'text': 'Бесплатная<br>доставка',
								'title': 'Бесплатная доставка'
							},
							{
								'code': 'gift',
								'text': 'Подарок'
							},
							{
								'src': './images/badges/fire.svg',
								'code': 'black_friday',
								'text': 'Чёрная<br>пятница',
								'title': 'Чёрная пятница'
							},
							{
								'src': './images/badges/price-guarantee.svg',
								'code': 'low_price',
								'text': 'Лучшая<br>цена',
								'title': 'Лучшая цена'
							},
							{
								'src': './images/badges/cyber-monday.svg',
								'code': 'cyber_monday',
								'text': 'Кибер<br>понедельник',
								'title': 'Кибер понедельник'
							},
              {
                'src': './images/badges/cyber-summer.svg',
                'code': 'cyber_summer',
                'text': 'Кибер<br>лето',
                'title': 'Кибер лето'
              },
							{
								'src': './images/badges/11-11.svg',
								'code': 'sale_11_11',
								'text': 'Роняем<br>цены',
								'title': 'Роняем цены'
							},
              {
                'code': 'duhrer',
                'link': 'https://www.google.com/',
                'title': 'Используется технология DűhrerSN',
              },
              {
                'code': 'schmieroll',
                'link': 'https://www.google.com/',
              },
						],
						'sale': null,
						'sales': [],
						'gifts': [
							{
								'src': './images/default-image/default-image.svg',
								'href': '#',
								'title': 'Какое-то описание Какое-то описание Какое-то описание Какое-то описание Какое-то описание Какое-то описание '
							},
							{
								'src': './images/default-image/default-image.svg',
								'href': '#',
								'title': 'Какое-то описание Какое-то описание Какое-то описание '
							},
							{
								'src': './images/default-image/default-image.svg',
								'href': '#',
								'title': 'Какое-то описание '
							},
							{
								'src': './images/default-image/default-image.svg',
								'href': '#',
								'title': 'Какое-то описание Какое-то описание Какое-то описание Какое-то описание Какое-то описание Какое-то описание Какое-то описание Какое-то описание '
							},
						]
					}
				],
				'photos': [
					{
						src: '',
						alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
					},
					{
						src: '/upload/iv_resize_cache/iblock/525/x8z4jbhowhq65dvlh42rrnl630lx87j1/microscope-telescope-binocular-levenhuk-labzz-mtb3_R90i5ho_190_190c90d8ac7541f58f7b6ddfe6e7f522a2f.webp',
						alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
					},
					{
						src: '/upload/iv_resize_cache/iblock/525/x8z4jbhowhq65dvlh42rrnl630lx87j1/microscope-telescope-binocular-levenhuk-labzz-mtb3_R90i5ho_190_190c90d8ac7541f58f7b6ddfe6e7f522a2f.webp',
						alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
					},
					{
						src: '/upload/iv_resize_cache/iblock/525/x8z4jbhowhq65dvlh42rrnl630lx87j1/microscope-telescope-binocular-levenhuk-labzz-mtb3_R90i5ho_190_190c90d8ac7541f58f7b6ddfe6e7f522a2f.webp',
						alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
					},
					{
						src: '/upload/iv_resize_cache/iblock/525/x8z4jbhowhq65dvlh42rrnl630lx87j1/microscope-telescope-binocular-levenhuk-labzz-mtb3_R90i5ho_190_190c90d8ac7541f58f7b6ddfe6e7f522a2f.webp',
						alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
					},
				],
			}
	};
	Array.from(document.querySelectorAll('.product-card:not(.product-card_inited)')).forEach((elem) => {
		elem.setAttribute('data-id', 25625);
		if (elem.classList.contains('product-card_small')) {
			new ProductCard({
				selector: `[data-id="${25625}"]:not(.product-card_inited)`, options: {
					data: {
						...options['data'],
						photos: [
							{
								src: '/upload/iv_resize_cache/iblock/525/x8z4jbhowhq65dvlh42rrnl630lx87j1/microscope-telescope-binocular-levenhuk-labzz-mtb3_R90i5ho_190_190c90d8ac7541f58f7b6ddfe6e7f522a2f.webp',
								alt: 'Набор Levenhuk LabZZ MTВ3: микроскоп, телескоп и бинокль',
							},
						]
					}
				}
			});
		} else {
			new ProductCard({
				selector: `[data-id="${25625}"]:not(.product-card_inited)`, options
			});
		}
	});
}


// Экспорт;
window.Block.ProductCard = ProductCard;
